<template>
  <div :style="{paddingTop: screenSize?'130px': '60px'}">
    <div class="w_header_logo" v-if="screenSize">
      <img v-if="screenSize=='large'" src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/belgium/images/text_01.png" alt="logo" />
      <img v-if="screenSize=='medium'" src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/belgium/images/text_01.png" alt="logo" />
      <img v-if="screenSize=='mini'" style="width: 400px;" src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/belgium/images/text_01.png" alt="logo" />
      <img v-if="screenSize=='small'" src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/belgium/images/text_02.png" alt="logo" style="width: 298px;"/>
      <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/belgium/images/close_icon.png" alt="" class="w-logo_close" @click="handleLogoClose">
    </div>
    <div class="w_header" :style="{top: screenSize?'70px': '0'}">
      <img src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/belgium/common_logo1.png" alt="导航按钮" />
      <div style="height:100%;display:flex;align-items: center;">
        <div v-if="!menufolding" class="w-header_levelMenu">
          <div :class="isActive == 1 ? 'is-active' : ''" @click="handMenu(1, 'Home')">{{ this.$t('navigation.index') }}</div>
          <div :class="isActive == 2 ? 'is-active' : ''" @click="handMenu(2, 'Product')">{{ this.$t('navigation.productCenter') }}</div>
          <div :class="isActive.toString().includes('3') ? 'is-active' : ''" @mouseover="ifPopover = true" @mouseleave="ifPopover = false">
            <span>{{ this.$t('navigation.solution') }}</span>
            <div v-if="ifPopover" class="w-levelMenu_solution" @mouseleave="ifPopover = false">
              <span :class="isActive == 3.1 ? 'is-active' : ''" @click="handMenu(3.1, 'Packaging')">{{ this.$t('navigation.digitalSolutionsForCircularPackaging') }}</span>
              <span :class="isActive == 3.2 ? 'is-active' : ''" @click="handMenu(3.2, 'Vehicle')">{{ this.$t('navigation.digitalSolutionForVehiclePositioning') }}</span>
            </div>
          </div>
          <div :class="isActive == 4 ? 'is-active' : ''" @click="handMenu(4, 'About')">{{ this.$t('navigation.aboutUs') }}</div>
          <div :class="isActive == 5 ? 'is-active' : ''" @click="handMenu(5, 'Connection')">{{ this.$t('navigation.contactUs') }}</div>
        </div>
        <!-- <div :class="{'w-custom_select':true,'open':isSelect}" ref="selectBox">
          <div class="w-select_button" id="selectButton" @click="handSelectButton">
            <i class="iconfont icon-icon_global"></i>
            <span id="w-select_text">{{ lang=='zh'?'简体中文':'English' }}</span>
            <i class="iconfont icon-icon_open"></i>
          </div>
          <div class="w-select_options" id="optionsList">
           <div class='w-option' :class="lang=='zh'?'w-option_avtive':''" @click="handSelectItem('zh')">简体中文</div>
            <div class='w-option' :class="lang=='en'?'w-option_avtive':''" @click="handSelectItem('en')">English</div>
          </div>
        </div> -->
        <div v-if="menufolding" class="w-header_mobileMenu">
          <i v-show="!isOpenMenu" class="iconfont icon-common_icon_menu" @click="isOpenMenu = true"></i>
          <i v-show="isOpenMenu" class="iconfont icon-common_icon_close" @click="isOpenMenu = false"></i>
        </div>
      </div>
      <div v-if="isOpenMenu" class="w-header_mobileMenu_list">
        <div @click="handMenu(1, 'Home')" class="w-transform_timing">
          <span :class="isActive == 1 ? 'is-active' : ''">{{ this.$t('navigation.index') }}</span>
          <i v-show="isOpenMenu" class="iconfont icon-common_icon_more"></i>
        </div>
        <div @click="handMenu(2, 'Product')" class="w-transform_timing">
          <span :class="isActive == 2 ? 'is-active' : ''">{{ this.$t('navigation.productCenter') }}</span>
          <i v-show="isOpenMenu" class="iconfont icon-common_icon_more"></i>
        </div>
        <div @click="handMenu(3.1, 'Packaging')" class="w-transform_timing">
          <span :class="isActive == 3.1 ? 'is-active' : ''">{{ this.$t('navigation.digitalSolutionsForCircularPackaging') }}</span>
          <i v-show="isOpenMenu" class="iconfont icon-common_icon_more"></i>
        </div>
        <div @click="handMenu(3.2, 'Vehicle')" class="w-transform_timing">
          <span :class="isActive == 3.2 ? 'is-active' : ''">{{ this.$t('navigation.digitalSolutionForVehiclePositioning') }}</span>
          <i v-show="isOpenMenu" class="iconfont icon-common_icon_more"></i>
        </div>
        <div @click="handMenu(4, 'About')" class="w-transform_timing">
          <span :class="isActive == 4 ? 'is-active' : ''">{{ this.$t('navigation.aboutUs') }}</span>
          <i v-show="isOpenMenu" class="iconfont icon-common_icon_more"></i>
        </div>
        <div @click="handMenu(5, 'Connection')" class="w-transform_timing">
          <span :class="isActive == 5 ? 'is-active' : ''">{{ this.$t('navigation.contactUs') }}</span>
          <i v-show="isOpenMenu" class="iconfont icon-common_icon_more"></i>
        </div>
      </div>
    </div>
    <component :is="componentId" :productId="productId" @openProdect="openProdect" @handMenu="handMenu"></component>
  </div>
</template>

<script>
import Home from './home.vue'
import Product from './product.vue'
import ProductDetail from './productDetail.vue'
import Packaging from './packaging.vue'
import Vehicle from './vehicle.vue'
import About from './about.vue'
import Connection from './connection.vue'
export default {
  data () {
    return {
      menufolding: false,
      isActive: 1,
      isSelect: false,
      ifPopover: false,
      componentId: localStorage.getItem('componentId') || 'Home',
      isOpenMenu: false,
      productId: null,
      lang: localStorage.getItem('lang') || 'zh',
      screenSize:'large',//屏幕尺寸
    }
  },
  components: {
    Home,
    Product,
    Packaging,
    Vehicle,
    About,
    Connection,
    ProductDetail
  },
  mounted () {
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize)
    // this.selectLanguage()
    // 立即检查一次当前窗口尺寸
    this.handleResize()
    localStorage.setItem('componentId', '')
  },
  methods: {
    handleResize () {
      this.menufolding = window.innerWidth < 1200
      if (window.innerWidth<480) this.screenSize='small'
      else if(window.innerWidth<768) this.screenSize='mini'
      else if(window.innerWidth<1200) this.screenSize='medium'
      else this.screenSize='large'
    },
    handMenu (id, route_) {
      this.isActive = id
      this.ifPopover = false
      this.componentId = route_
      this.isOpenMenu = false
    },
    openProdect (data) {
      let { activeId, menuName, prodectId } = data
      this.productId = prodectId
      this.handMenu(activeId, menuName)
    },
    handSelectButton () {//  选择语言按钮点击事件
      this.isSelect = true
    },
    handSelectItem (data) {// 选择语言选项点击事件
      this.isSelect = false
      localStorage.setItem('lang', data)
      localStorage.setItem('componentId', this.componentId)
      location.reload();
    },
    selectLanguage () {
      const optionsList = document.getElementById('optionsList');
      // 处理选项点击事件
      // 点击其他地方关闭下拉菜单
      document.addEventListener('click', (event) => {
        if (!event.target.closest('.w-custom_select'))        {
          optionsList.parentElement.classList.remove('open');
        }
      });
    },
    handleLogoClose(){
      this.screenSize=''
    }
  },
  updated () {
    // 组件更新后，确保滚动到顶部
    this.$nextTick(() => {
      window.scrollTo(0, 0);
    });
  },
  beforeDestroy () {
    // 移除事件监听器，防止内存泄漏
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>
<style lang="scss">
@keyframes arrow {
  0% {
    transform: translateX(370px);
  }
  100% {
    transform: translateX(-100%);
  } /* 移动到容器外 */
}
.w_header_logo{
  position: fixed;
  top: 0;
  left: 0;
  width:100%;
  height: 70px;
  background-image: url('https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/belgium/images/banner_bg_01.png');
  background-size: 100% 709px;
  background-position-y: 50%;
  background-repeat: no-repeat;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  .w-logo_close{
    position: absolute;
    right: 16px;
    top: 23px;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
}


.icon {
  width: 1em;
  height: 1em;
  vertical-align: -0.15em;
  fill: currentColor;
  overflow: hidden;
}
.w_header {
  box-sizing: border-box;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(220, 224, 236, 0.6);
  position: fixed;
  top: 70px;
  left: 0;
  background: #ffffff;
  z-index: 999;
  & > img {
    width: 100px;
    height: 24px;
    image-rendering: crisp-edges;
  }
  .w-header_levelMenu {
    display: flex;
    & > div {
      height: 24px;
      font-weight: 400;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.6);
      line-height: 24px;
      margin-right: 80px;
      cursor: pointer;
    }
    & > div:last-of-type {
      margin-right: 0;
    }
    & > div:nth-child(3) {
      position: relative;
      cursor: default;
      .w-levelMenu_solution {
        height: 122px;
        padding: 26px 0 8px;
        position: absolute;
        left: -59px;
        top: 100%;
        background: #fff;
        & > span {
          display: flex;
          justify-content: center;
          align-items: center;
          // width: 100%;
          height: 63px;
          font-weight: 400;
          font-size: 14px;
          color: rgba(0, 0, 0, 0.6);
          line-height: 16px;
          white-space: nowrap;
          padding: 0 10px;
          cursor: pointer;
        }
        & > span:hover {
          font-family: 'Source Han Sans-Medium';
          color: rgba(0, 0, 0, 0.85);
          background: rgba(143, 151, 178, 0.1);
        }
        .is-active {
          font-weight: bold;
          color: rgba(0, 0, 0, 0.85);
        }
      }
    }
    .is-active {
      font-family: 'Source Han Sans-Bold';
      font-weight: bold;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  .w-header_mobileMenu {
    .iconfont {
      cursor: pointer;
    }
  }
  .w-header_mobileMenu_list {
    box-sizing: border-box;
    width: 100%;
    height: calc(100vh - 60px);
    position: absolute;
    left: 0;
    top: 60px;
    padding: 8px 16px 0;
    background: #ffffff;
    overflow-y: auto;
    z-index: 999;
    animation: moveAndFadeIn 0.4s ease-in-out forwards;
    & > div {
      box-sizing: border-box;
      width: 100%;
      height: 56px;
      border-bottom: 1px solid rgba(220, 224, 236, 0.4);
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 16px;

      span {
        display: inline-block;
        height: 24px;
        font-weight: 400;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 25px;
      }
      .is-active {
        color: #286aea;
      }
    }
    & > div:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
